import React from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
const COST_ELEMENTS = ['Session structuring & chaptering into interactive Snak format', 'Interactive engagement layer — polls, quizzes & completion tracking with first-party data capture', '3-month performance readout — view depth, topic analysis and recommendations, delivered as one reporting session', 'Editing, light visual polish, QA and delivery across all 3 sessions'];
export function Slide03CostEstimate({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--bg)] p-[clamp(2rem,4vw,4rem)] flex flex-col" data-id="element-82" data-mp="3unpc31z5kbab">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(2rem,3vw,3rem)]" data-id="element-83" data-mp="8eemxxdob7i0">
        <p className="text-[var(--brand-green)] text-[clamp(0.875rem,1.5vw,1.125rem)] font-semibold uppercase tracking-wider mb-[clamp(0.5rem,1vw,1rem)]" data-id="element-84" data-mp="2a8488v5r3hp0">
          5. Key Cost Elements &amp; Estimate
        </p>
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,3.5vw,3rem)] leading-[1.1]" data-id="element-85" data-mp="16ajx0f9mr80k">
          A lean,{' '}
          <span className="text-[var(--brand-green-light)]" data-id="element-86" data-mp="1b1a17p6bl4to">
            transparent estimate
          </span>
          .
        </h2>
      </motion.div>

      <div className="flex-1 grid grid-cols-12 gap-[clamp(2rem,4vw,4rem)] min-h-0" data-id="element-87" data-mp="1g27i7yflfstl">
        {/* Left: Key cost elements */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.35,
        duration: 0.6
      }} className="col-span-7 flex flex-col justify-center" data-id="element-88" data-mp="1p11bbetpu12e">
          <h3 className="text-[var(--brand-green)] font-bold text-2xl mb-6" data-id="element-89" data-mp="3vs0ri7rybf4m">
            Key Cost Elements
          </h3>
          <ul className="space-y-4" data-id="element-90" data-mp="12x0xgquwmacd">
            {COST_ELEMENTS.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-91" data-mp="xz8t2xd2ovra" data-mpi={i}>
                <span className="w-6 h-6 rounded-full bg-[var(--brand-green)] flex items-center justify-center flex-shrink-0 mt-0.5 text-white text-xs font-bold" data-id="element-92" data-mp="1bxyrqhfjj3hr">
                  {i + 1}
                </span>
                <span className="text-[var(--fg)] text-[clamp(1rem,1.25vw,1.2rem)] leading-snug" data-id="element-93" data-mp="1lutn4rgionrt">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* Right: Price Card */}
        <div className="col-span-5 flex flex-col justify-center" data-id="element-94" data-mp="1uq195v00ant2">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="bg-[var(--brand-green)] rounded-2xl p-[clamp(2rem,3vw,3rem)] shadow-xl text-white" data-id="element-95" data-mp="1qnmsnhjt804y">
            <p className="text-[var(--brand-green-lighter)] font-semibold uppercase tracking-wider text-sm mb-2" data-id="element-96" data-mp="2o74vk8gy0uje">
              Base — Evergreen Snak Content · Chronic Hand Eczema Webinar
            </p>
            <div className="text-[clamp(3rem,4.5vw,4rem)] font-bold leading-none mb-3" data-id="element-97" data-mp="2e7vukvnnufnj">
              10,500€
            </div>
            <p className="text-white/90 text-[clamp(0.95rem,1.15vw,1.1rem)] font-medium mb-5" data-id="element-98" data-mp="25921vgdga9f9">
              One interactive DERMX Snak based on the November webinar, repeated
              across 3 live sessions, plus the 3-month performance readout.
            </p>

            <div className="w-full h-px bg-white/20 mb-5" data-id="element-99" data-mp="1vjif3zmm9vf4" />

            <p className="text-[var(--brand-green-lighter)] font-semibold uppercase tracking-wider text-sm mb-3" data-id="element-100" data-mp="1hj7pezx1mmvj">
              Optional Add-ons
            </p>
            <div className="space-y-4" data-id="element-101" data-mp="1lmw03rgz1yl0">
              <div className="flex items-end justify-between gap-4" data-id="element-102" data-mp="1egtfv3aug9ix">
                <div data-id="element-103" data-mp="19j1oqbi0wrfs">
                  <p className="font-semibold text-white" data-id="element-104" data-mp="19ii76vwac52a">Language localization</p>
                  <p className="text-xs text-white/60" data-id="element-105" data-mp="14rryp9skbm3d">Per additional language</p>
                </div>
                <p className="text-[clamp(1.4rem,2vw,1.8rem)] font-bold leading-none whitespace-nowrap" data-id="element-106" data-mp="zti533mhktjv">
                  +1,000€
                </p>
              </div>
              <div className="h-px bg-white/15" data-id="element-107" data-mp="vp0o1c7igucs" />
              <div className="flex items-end justify-between gap-4" data-id="element-108" data-mp="qr8ukdr7x06h">
                <div data-id="element-109" data-mp="lsxjjzp6sjmo">
                  <p className="font-semibold text-white" data-id="element-110" data-mp="lu8pa52701gf">KOL Teaser Snak</p>
                  <p className="text-xs text-white/60" data-id="element-111" data-mp="gucnmcgywm41">Per selected teaser</p>
                </div>
                <p className="text-[clamp(1.4rem,2vw,1.8rem)] font-bold leading-none whitespace-nowrap" data-id="element-112" data-mp="2g6ymowrrrssk">
                  +2,000€
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8,
      duration: 0.6
    }} className="flex justify-between items-end mt-4" data-id="element-113" data-mp="2jn1onf1ffu9k">
        <p className="text-[var(--fg)] text-[clamp(1rem,1.25vw,1.25rem)] font-semibold" data-id="element-114" data-mp="2xf7uo8av8kva">
          Start with the evergreen foundation; add languages and Teaser Snaks only where needed.
        </p>
      </motion.div>
    </div>;
}